import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {userId} from '/redux/selector/currentUser.selector';
import {
  atRiskExpiringCoachRenewalsById,
  atRiskNotCertifiedById,
} from '/redux/selector/metric.teams.selector';
import {withProps} from '/util/selector.util';

import NeedAttentionSection from './NeedAttentionSection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    expiringCoachRenewal: withCoachUserId(atRiskExpiringCoachRenewalsById),
    notCertified: withCoachUserId(atRiskNotCertifiedById),
  }),
)(NeedAttentionSection);
